module.exports = __webpack_public_path__ + "static/media/2_en.7f49b428.png";